import { cn } from "utils";
import { memo } from "react";
import { ViewMoreProps, ViewMoreState, withViewMore } from "./withViewMore";

import NextImage from "@/src/components/NextImage";

interface Investor {
  avatar: string;
  name: string;
}

export interface InvestorsProps extends ViewMoreProps {
  /** 投资者数据 */
  investors?: Investor[];
  /** 投资者项自定义类名 */
  investorItemClassName?: string;
  /** 投资者头像宽度 */
  imageWidth?: number;
  /** 投资者头像高度 */
  imageHeight?: number;
  /** 投资者名称自定义类名 */
  nameClassName?: string;
}

interface InvestorsComponentProps extends InvestorsProps {
  viewMoreState: ViewMoreState;
  data: Investor[];
}

// 投资者组件（内部实现）
const InvestorsComponent = (props: InvestorsComponentProps) => {
  const {
    viewMoreState,
    data,
    investorItemClassName,
    imageWidth = 40,
    imageHeight = 40,
    nameClassName,
    containerClassName,
  } = props;

  const { containerRef, itemRef, containerHeight, enableViewMore } =
    viewMoreState;

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={cn(
        "flex flex-wrap flex-row gap-4 relative",
        enableViewMore && "overflow-hidden transition-all duration-300",
        containerClassName,
      )}
      style={enableViewMore ? { height: containerHeight } : undefined}
    >
      {data.map((investor, index) => (
        <div
          key={index}
          ref={index === 0 ? itemRef : undefined}
          className={cn(
            "flex flex-row items-center justify-center py-2 px-3 rounded-[12px] bg-background_white_overlay5 gap-3",
            investorItemClassName,
          )}
        >
          <NextImage
            src={investor.avatar}
            alt={investor.name}
            className="rounded-full"
            width={imageWidth}
            height={imageHeight}
          />
          <span
            className={cn(
              "body_medium_s text-content_secondary",
              nameClassName,
            )}
          >
            {investor.name}
          </span>
        </div>
      ))}
    </div>
  );
};

// 使用高阶组件增强Investors
const Investors = withViewMore<InvestorsProps, Investor>(
  InvestorsComponent,
  "Investors",
  (props) => props.investors,
);

export default memo(Investors);
